import { isNil } from '@lucidlink/tscore';
import { AuthorizationError } from '#common/types';
export function createAuthorizer(idService, telemetryClient) {
    return new Authorizer(idService, telemetryClient);
}
export class Authorizer {
    idService;
    telemetryClient;
    constructor(idService, telemetryClient) {
        this.idService = idService;
        this.telemetryClient = telemetryClient;
    }
    async executeWithAdminPrivileges(operation, telemetry) {
        await this.ensureAdminPrivileges();
        const result = await operation();
        this.sendTelemetry(telemetry);
        return result;
    }
    async ensureAdminPrivileges() {
        const principalInfo = await this.idService.getCurrentPrincipalInfo();
        if (!principalInfo.isAdmin) {
            throw new AuthorizationError('Admin privilege required');
        }
    }
    sendTelemetry(telemetry) {
        if (isNil(telemetry)) {
            return;
        }
        this.telemetryClient.sendMetrics(telemetry.operation, telemetry.telemetryValue);
    }
}
